<script>
import BaseButton from '@/js/components/common/buttons/BaseButton';

export default {
    name: 'CreateButton',

    functional: true,

    props: {
        type: {type: String, default: 'button'},
        label: {type: String, default: null},
        hideLabel: {type: Boolean},
        isSmall: {type: Boolean},
        isLoading: {type: Boolean},
        disabled: {type: Boolean},
    },

    render(createElement, {props, data, parent}) {
        data.props = {
            label: props.label || parent.$t('common.actions.create'),
            iconClass: 'fa fa-plus',
            color: 'btn-success',
            isSmall: props.isSmall,
            hideLabel: props.hideLabel,
            isLoading: props.isLoading,
            disabled: props.disabled,
            type: props.type,
        };

        return createElement(BaseButton, data);
    },
};
</script>
